import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=716230b2&scoped=true&lang=pug&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=716230b2&prod&lang=scss&scoped=true&"
import style1 from "./Result.vue?vue&type=style&index=1&id=716230b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716230b2",
  null
  
)

export default component.exports